var gdprModal = {
		elem: $('.gdpr-modal'),
		detailElem: $('.update-details-modal'),
		buttonInit: $('#optInContact'),
		buttonOut: $('#optOutContacts'),
		buttonNext: $('.next-item'),
		gdprItems: $('.gdpr-modal-content .gdpr-type-item'),
		currentNum: $('.page-num .current-num'),
		genInit: $('.gdpr-details-init'),

	generic: function() {

		// var gdprTotal = gdprModal.gdprItems.length;
		// $('.page-num').append(gdprTotal);
		$('.first.pag-num-item').css('display', 'inline');
		$('.second.pag-num-item').hide();
		gdprModal.buttonInit.on('change', function(){
			if($(this).is(':checked') === false){
				$(this).prop('checked', false);
			} else {
				$('.none-selected').hide();
				gdprModal.modalOpen();
			}
		});
		gdprModal.pagModelNum();
		gdprDetails.locationDependentChecker();
		gdprModal.dependancyCheckLocation();
		gdprModal.genInit.on('click', gdprModal.modalOpen);
		gdprModal.buttonOut.on('change', gdprModal.nonSelectHide);
		gdprModal.buttonNext.on('click', function(e){
			e.preventDefault();
			console.log('NEXT');
			var $t = $(this);
			gdprModal.modalNext($t);
		});
		$('.gdpr-submit').on('click', function (e) {
			var $optIn = $('#optInContact'),
					$optOut = $('#optOutContacts');
			if ($optIn.is(':checked') === false && $optOut.is(':checked') === false) {
			    $('.none-selected').removeClass('hide');
			    $('.none-selected').show();
			    e.preventDefault();
			}
		});
	},

	pagModelNum: function() {
		var $pagNum = $('.pag-num-item');

		$pagNum.each(function(){
			var $currentPagNum = $(this);
					pagText = $currentPagNum.text(),
					clearTextFirst = pagText.substr(1),
					currentFirstString = pagText.charAt(0).toString();


					$currentPagNum.empty();
					$currentPagNum.html('<strong>' + currentFirstString + '</strong>' + clearTextFirst);
		});



	},

	nonSelectHide: function(){
		if (gdprModal.buttonInit.is(':checked') === true){
			gdprModal.buttonInit.prop('checked', false);
			$('.hidden-inputs input').attr('value', false);
		}
		$('.none-selected').hide();
	},

	modalOpen: function(){
		var $this = $(this),
				$thisCheckCheck = $this.is(':checked');

		if($this.hasClass('gdpr-details-init') === true){
			var $thisId = $this.attr('id');
					gdprModal.modelDetail($thisId, $thisCheckCheck);
		} else {
			gdprModal.elem.addClass('show');
			if (gdprModal.elem.hasClass('terms-page-modal') === true){
				if(gdprModal.buttonOut.is(':checked') === true){
					gdprModal.changeCheckState(gdprModal.buttonOut, 'uncheck');
				}
			}
		}
	},

	modelDetail: function(currentId, checkStatus){
		var $detailModalItem = $('.update-details-modal .gdpr-type-item');

		$detailModalItem.each(function(index){
			var $this = $(this),
					currentData = $this.attr('data-typeContent');
			if(currentData === currentId){
				if(currentId === 'locationOptInLink'){
					var lStatus = $('#' + currentId).hasClass('allowed');
					if(lStatus === true){
						$this.find('.disable-container').show();
						$this.find('.enable-container').hide();
					} else {
						$this.find('.disable-container').hide();
						$this.find('.enable-container').show();
					}
				} else {
					if(checkStatus === true){
						$this.find('.disable-container').hide();
						$this.find('.enable-container').show();
					} else {
						$this.find('.disable-container').show();
						$this.find('.enable-container').hide();
					}
				}

				$this.show();
			}
		});
		gdprModal.elem.addClass('show');
	},

	paginationClear: function(){
		if(gdprModal.elem.hasClass('terms-page-modal') === true){

			gdprModal.currentNum.empty();
			gdprModal.currentNum.append(1);
			$('.pag-num-item.first').css('display', 'inline');
			$('.pag-num-item.second').hide();
		}
	},

	modalClose: function(){
		gdprModal.elem.addClass('fade-out');
		window.setTimeout(gdprModal.modalReset, 300);
	},
	modalReset: function(){
		$('.pag-num-item.first').css('display', 'inline');
		$('.pag-num-item.second').hide();
		gdprModal.elem.removeClass('show');
		gdprModal.elem.removeClass('fade-out');
		gdprModal.gdprItems.hide();
		if (gdprModal.elem.hasClass('terms-page-modal') === true){
			var $firstItem = $('.gdpr-modal-content .gdpr-type-item:first-child');
			gdprModal.gdprItems.removeClass('active');
			$firstItem.addClass('active');
			$firstItem.show();
		}
	},

	hiddenInputVal: function($t, isMulti){
		var inputRel = $t.attr('data-inputRel'),
				inputVal = $t.attr('data-inputVal');

			if(isMulti === 'yes'){
				$('.hidden-inputs input').attr('value', false);
			}
			$('.hidden-inputs input[name="' + inputRel + '"]').attr('value', inputVal);
	},

	modalNext: function($this){
		var ind = $this.parents('.gdpr-type-item').index(),
				indeNext = ind + 2,
				indeCurrent = ind + 1;
				$t = $('.gdpr-type-item:nth-child(' + indeNext + ')');

				gdprModal.hiddenInputVal($this);

				if (gdprModal.elem.hasClass('terms-page-modal') === true){
					gdprModal.multiPageGDPR(indeCurrent, $t, $this);
					gdprModal.currentNum.empty();
					if (indeNext > gdprModal.gdprItems.length){
						//gdprModal.currentNum.append(gdprModal.gdprItems.length);
					} else {
						$('.pag-num-item.second').css('display', 'inline');
						$('.pag-num-item.first').hide();
						gdprModal.currentNum.append(indeNext);
					}
				} else {
					gdprModal.modalClose();
					gdprModal.modalReset();
					gdprModal.detailDecision($this);
				}
	},



	detailDecision: function($this){
		var parentData = $this.parents('.gdpr-type-item').attr('data-typeContent');
			if(parentData === 'locationOptInLink'){
				if($this.hasClass('allow')){
					gdprDetails.locationAllowed();
				} else {
					// gdprDetails.init();
					gdprDetails.locationNotAllowed();
				}
			} else {

				if($this.hasClass('allow')){
					$('#'+ parentData).prop('checked', true);
					if(parentData === 'PushSmsOptIn'){
						$('#MobileDependancyCheck').attr('value', true);
					} else if (parentData === 'EmailOptIn'){
						$('#EmailDependancyCheck').attr('value', true);
					}
					gdprModal.dependancyCheckLocation();

				} else {
					$('#'+ parentData).prop('checked', false);
					if(parentData === 'PushSmsOptIn'){
						$('#MobileDependancyCheck').attr('value', 'False');
					} else if (parentData === 'EmailOptIn'){
						$('#EmailDependancyCheck').attr('value', 'False');
					}
					gdprModal.dependancyCheckLocation();
					gdprDetails.locationDependentChecker();
				}
			}
	},

	dependancyCheckLocation: function(){

		if($('#MobileDependancyCheck').length > 0){
			var mobileCheckVal = $('#MobileDependancyCheck').attr('value').toLowerCase(),
					emailCheckVal = $('#EmailDependancyCheck').attr('value').toLowerCase();


			if (mobileCheckVal === 'false' && emailCheckVal === 'false'){
				$('.gdpr-pref-item.location').addClass('is-empty');

			} else {
				$('.gdpr-pref-item.location').removeClass('is-empty');
			}
		}


	},

	multiPageGDPR: function(indeCurrent, $t, $this){
		if (indeCurrent === 1 && $this.hasClass('dont-allow') === true){
			gdprModal.changeCheckState(gdprModal.buttonInit, 'uncheck');
			gdprModal.changeCheckState(gdprModal.buttonOut, 'check');
			gdprModal.modalClose();
			gdprModal.hiddenInputVal($t, 'yes')

		} else {
			gdprModal.modalPagination(indeCurrent, $t);
		}
	},

	changeCheckState: function($checkBox, state){
		if(state === 'check'){
			$checkBox.prop('checked', true);
		} else {
			$checkBox.prop('checked', false);
		}
	},

	modalPagination: function(indeCurrent, $t){
		if(gdprModal.elem.hasClass('terms-page-modal') === true){
			var gdprTotal = gdprModal.gdprItems.length;
			if(indeCurrent === gdprTotal){
				gdprModal.modalClose();
			} else {
				gdprModal.gdprItems.hide();
				gdprModal.gdprItems.removeClass('active');
				$t.fadeIn();
				$t.addClass('active');
			}
		}
	},

	init: function() {
		gdprModal.generic();
	}
};
